import React, { FC, useEffect, useRef } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { useBreakpoint } from '@shared/lib/react';
const PartnerAnimatedBackground: FC = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const {
    isMobile
  } = useBreakpoint();
  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;
    const renderStarGroup = (top: number, html: string) => `<div class="star-group" style="
        top: ${top}px;
        --translateY: -${window.innerHeight}px"
      >${html}</div>`;
    const randomInt = (max: number) => Math.floor(Math.random() * max);
    const renderStar = (count: number, className: string) => {
      let html = '';
      for (let i = 0; i < count; i++) {
        html += `<div class="star ${className}" style="
          top: ${randomInt(window.innerHeight)}px;
          right: ${randomInt(window.innerWidth)}px;
        "></div>`;
      }
      return renderStarGroup(0, html) + renderStarGroup(window.innerHeight, html);
    };
    const renderAllStars = () => {
      if (!wrapper) return;
      wrapper.innerHTML = '';
      const bigCount = isMobile ? 5 : 20;
      const avgCount = isMobile ? 20 : 90;
      const smallCount = isMobile ? 40 : 180;
      const allHtml = renderStar(bigCount, 'big-star') + renderStar(avgCount, 'average-star') + renderStar(smallCount, 'small-star');
      wrapper.innerHTML = allHtml;
    };
    renderAllStars();
    return () => {
      if (wrapper) {
        wrapper.innerHTML = '';
      }
    };
  }, []);
  return <PartnerAnimatedBackgroundWrapper ref={wrapperRef} />;
};
export default PartnerAnimatedBackground;
const _exp = /*#__PURE__*/() => ({
  theme
}) => `radial-gradient(ellipse at bottom, ${theme.colors.background.gradientAccent} 0%, ${theme.colors.background.gradientSecondary} 100%)`;
const PartnerAnimatedBackgroundWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "PartnerAnimatedBackgroundWrapper",
  class: "ptuhkz",
  propsAsIs: false,
  vars: {
    "ptuhkz-0": [_exp()]
  }
}));

require("./PartnerAnimatedBackground.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./PartnerAnimatedBackground.tsx");